import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class DocumentService {
    constructor( private http: HttpClient, private oktaService: OktaService ) {}

    getImage( id: string ): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);

        return this.http.get(environment.azure.url + '/document?file=' + id, { responseType: 'blob', headers: headers });  
    }

    addImage( file: File ): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        let formData = new FormData();
        formData.append("file", file);
        
        return this.http.post<any>(environment.azure.url + '/admin.document.add', formData, options);
    }

    removeImage( id: string ): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        return this.http.delete<any>(environment.azure.url + '/admin.document.remove?file=' + id, options);  
    }

    convertDataURIToBinary(dataBuffer: any, type: string): string {
        let binary = '';
        const bytes = new Uint8Array( dataBuffer );
        const len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
        } 

        const base64String = window.btoa( binary );

        return 'data:' + type + ';base64, ' + base64String;
    }
}